export async function readApiJson(response, label = "Data") {
  const unavailable = `${label} could not be loaded. The service is unavailable. Please try again.`;
  const contentType = response.headers?.get("content-type") || "";
  if (contentType && !/\bjson\b/i.test(contentType)) {
    throw new Error(unavailable);
  }
  let payload;
  try {
    payload = await response.json();
  } catch {
    throw new Error(unavailable);
  }
  if (!response.ok) {
    throw new Error(payload?.error || payload?.message || unavailable);
  }
  if (payload == null || typeof payload !== "object") throw new Error(unavailable);
  return payload;
}
